import { useContext, useEffect } from 'react';
import { BandCard } from './BandCard';
import { GlobalContext } from '../context/GlobalState';

export const BandsTab = () => {
  const { bands, isLoggedIn, userId, loadBands, isBandsLoading, bandsLoaded } =
    useContext(GlobalContext);

  useEffect(() => {
    loadBands();
  }, [loadBands]);

  const visibleBands = isLoggedIn
    ? bands.filter(band => band.userId !== userId)
    : bands;

  if (isBandsLoading && !bandsLoaded) {
    return <div className='message'>Loading bands...</div>;
  }

  if (bandsLoaded && visibleBands.length === 0) {
    return <div className='message'>No band listings found.</div>;
  }

  return (
    <ul className='cards'>
      {visibleBands.map(band => (
        <BandCard key={band._id} band={band} />
      ))}
    </ul>
  );
};
